import {Injectable, signal} from '@angular/core';

@Injectable({providedIn: 'root'})
export class NetworkService {

  public online = signal(true)
  public showOffline = signal(false)

  public showNetworkError = signal(false)

}
